import Vue from 'vue'
import { URL_LOTS } from '@/constants/urls.js'
import { LOT_WINNERS_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOT_WINNERS_MANAGEMENT.STATE.WINNER_SELECTION_LIST]: null
}

const actions = {
  async [LOT_WINNERS_MANAGEMENT.ACTIONS.GET_WINNER_SELECTION_LIST] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/winnerSelection?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_WINNERS_MANAGEMENT.MUTATIONS.GET_WINNER_SELECTION_LIST, resp.data)
  },
  async [LOT_WINNERS_MANAGEMENT.ACTIONS.SELECT_WINNERS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/winnerSelection`,
      model: model.result
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_WINNERS_MANAGEMENT.ACTIONS.UPDATE_WINNERS] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}/winnerSelection`,
      model: model.result
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_WINNERS_MANAGEMENT.ACTIONS.CLEAR_WINNER_SELECTION_LIST] ({ commit }) {
    commit(LOT_WINNERS_MANAGEMENT.MUTATIONS.CLEAR_WINNER_SELECTION_LIST)
  }
}

const mutations = {
  [LOT_WINNERS_MANAGEMENT.MUTATIONS.GET_WINNER_SELECTION_LIST] (state, list) {
    state[LOT_WINNERS_MANAGEMENT.STATE.WINNER_SELECTION_LIST] = list
  },
  [LOT_WINNERS_MANAGEMENT.MUTATIONS.CLEAR_WINNER_SELECTION_LIST] (state) {
    state[LOT_WINNERS_MANAGEMENT.STATE.WINNER_SELECTION_LIST] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
